import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getSectionVisibleActionType } from 'src/redux/visibilityTracking';
import { onDeliveryAreaToggle } from '../modules';
import { onDeliveryAreaReturnsPolicyClick } from '../modules/actions';
import {
  DELIVERY_AREA_VISIBILITY_NAME,
  DeliveryAreaImpression,
  DeliveryAreaReturnsPolicy,
  DeliveryAreaToggle,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [getSectionVisibleActionType(DELIVERY_AREA_VISIBILITY_NAME)]: () => {
    sendGAEvent<DeliveryAreaImpression>({
      event: 'custom_event',
      event_category: 'Delivery & Returns',
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
  [onDeliveryAreaToggle.type]: (_, __, action) => {
    const { payload: isOpen } = action as ReturnType<typeof onDeliveryAreaToggle>;

    sendGAEvent<DeliveryAreaToggle>({
      event: 'custom_event',
      event_action: !isOpen ? 'Collapse' : 'Expand',
      event_category: 'Delivery & Returns',
      event_label: 'not set',
    });
  },
  [onDeliveryAreaReturnsPolicyClick.type]: () => {
    sendGAEvent<DeliveryAreaReturnsPolicy>({
      event: 'custom_event',
      event_action: 'Returns policy click',
      event_category: 'Delivery & Returns',
      event_label: 'not set',
    });
  },
};
